import { parseDate, sortDates } from "../../../../utilities";
export const optionsInputsKnoweledgeTestRecord = {
  programId: {
    key: "programId",
    label: "Программа подготовки",
    options: [],
    type: "selectSearch",
    required: true,
    disabled: false,
    searchable: false,
  },
  protDate: {
    key: "protDate",
    label: "Дата протокола",
    type: "date",
    required: true,
    disabled: false,
    customValidation: (value, data) => {
      let error = "";

      if (new Date(value) >= new Date()) {
        error = "Дата не может быть позднее текущей";
      }

      return error || true;
    },
  },
  protNum: {
    key: "protNum",
    label: "Номер протокола",
    type: "text",
    required: true,
    disabled: false,
  },
  examType: {
    key: "examType",
    label: "/",
    type: "selectSearch",
    required: true,
    disabled: false,
    searchable: false,
    options: [
      { value: 1, label: "1", key: "examType" },
      { value: 2, label: "2", key: "examType" },
    ],
  },
  examTypeName: {
    key: "examTypeName",
    label: "Форма проверки знаний",
    type: "text",
    required: true,
    disabled: true,
    fieldModeView: true,
  },
};
export const columnsKnoweledgeTestRecordTable = {
  index: {
    Header: "№",
    accessor: (row, index) => index + 1, // Функция для вычисления номера строки
    Cell: (cellProps) => {
      return <div>{cellProps.row.index + 1}</div>;
    },
    editable: false,
    show: true,
    viewType: "text",
  },
  fio: {
    Header: "ФИО",
    accessor: "fio",
    editable: false,
    show: true,
    viewType: "text",
  },
  birthDate: {
    Header: "Дата рождения",
    accessor: "birthDate",
    editable: false,
    viewType: "text",
    show: true,
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  ticketNum: {
    Header: "Номер билета",
    accessor: "ticketNum",
    editable: true,
    typeEdit: "text",
    show: true,
    required: true,
    viewType: "text",
  },
  passed: {
    Header: "Отметка",
    accessor: "passed",
    editable: true,
    typeEdit: "select",
    viewType: "text",
    required: true,
    show: true,
    selectOptions: [
      { id: 0, value: "Выберите", selected: "selected", disabled: "disabled", hidden: "hidden" },
      { id: 1, value: "Зачтено" },
      { id: 2, value: "Не зачтено" },
      { id: 3, value: "Неявка" },
      { id: 4, value: "Не допущен" },
    ],
  },
  deleteRow: {
    Header: "",
    accessor: "deleteRow",
    editable: false,
    typeEdit: "text",
    viewType: "button",
    naming: "X",
    show: true,
    style: "delete-button",
  },
};

export const customStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isDisabled ? "#F4EEE6 !important" : "#fff",
    border: "1px solid #BC865399",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: "#233E5A",
  }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isDisabled ? "transparent" : "#BC865380",
  }),
  dropdownIndicator: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isDisabled ? "transparent" : "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isDisabled ? "transparent" : "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
export const customErrorStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isDisabled ? "#F4EEE6 !important" : "#fff",
    border: "1px solid #dc3545",
    borderRadius: "6px",
    boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: state.isDisabled ? "#233E5A" : "#233E5A",
    padding: "4px 0",
    "&:hover": {
      border: "1px solid #BC865399",
    },
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    color: state.isDisabled ? "#233E5A" : "#233E5A",
    // color: "#233E5A",
  }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isDisabled ? "transparent" : "#BC865380",
  }),
  dropdownIndicator: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isDisabled ? "transparent" : "#BC865399",
    "&:hover": {
      color: "#BC865399",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isDisabled ? "transparent" : "#BC865399",
  }),
  noOptionsMessage: (baseStyles) => ({
    ...baseStyles,
    color: "#BC865380",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    fontFamily: "RobotoRegular",
    fontSize: "16px",
    lineHeight: "21px",
    letterSpacing: "0px",
    textAlign: "left",
    backgroundColor: state.isSelected ? "#BC8653" : "",
    color: state.isSelected ? "#F4F7FA" : "#233E5A",
    "&:hover": {
      color: "#F4F7FA",
      backgroundColor: "#BC865380",
      cursor: "pointer",
    },
  }),
};
export const setOptionsKnoweledgeTestRecord = (prop, key) => {
  switch (key) {
    case optionsInputsKnoweledgeTestRecord.programId.key: {
      optionsInputsKnoweledgeTestRecord.programId.options = prop;
      break;
    }
    case columnsKnoweledgeTestRecordTable.ticketNum.accessor: {
      columnsKnoweledgeTestRecordTable.ticketNum.show = prop;
      columnsKnoweledgeTestRecordTable.ticketNum.required = prop;
      columnsKnoweledgeTestRecordTable.passed.required = prop;
    }
    default:
      break;
  }
};
